module.exports = __webpack_public_path__ + "static/media/ines.817956d4.jpg";